import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import SecondaryButton from './SecondaryButton';

import { ReactComponent as FilterIcon } from '../../icons/filter.svg';

const FiltersButton = ({ hasIndicator, children, tooltip, style, ...rest }) => {
    const intl = useIntl();
    tooltip = tooltip ? tooltip : intl.formatMessage({ id: 'common_filters_btn_tooltip' });
    return (
        <Tooltip label={tooltip} shouldWrapChildren sx={style}>
            <SecondaryButton
                leftIcon={<FilterIcon />}
                rightIcon={hasIndicator && <IndicatorIcon />}
                type="button"
                variant="secondary"
                size="sm"
                {...rest}
            >
                {children || <FormattedMessage id="common_filters_btn" />}
            </SecondaryButton>
        </Tooltip>
    );
};

const IndicatorIcon = styled.div`
    background: var(--chakra-colors-blue-400);
    height: 6px;
    width: 6px;
    border-radius: var(--chakra-radii-md);
    margin-top: -10px;
`;

export default FiltersButton;
